import Axios from "axios";

const utils = {
  async saveData(fullname,email,scores) {
    return new Promise( (resolve,reject)=>{
      const code = email.indexOf("@")>-1 ? email.split("@")[0] : "00000000";
      const data = {
        ident:"days",
        fullname:fullname,
        email:email,
        code:code,
        results:scores
      }
  
      const url = process.env.VUE_APP_BACKEND_URL;
      const tokenStr = "card-game!";
      const params = data;

      Axios.post(url+"/cardGame/save",params,{ headers:{"Authorization": `Bearer ${tokenStr}` }}).then(returnData=>{
        resolve("ok");
      })   
    });
  }  
}

export default utils;